import { Injectable, PLATFORM_ID, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "src/environments/environment";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private platformId = inject(PLATFORM_ID);
  private http = inject(HttpClient);
  private router = inject(Router);

  private tokenSubject!: BehaviorSubject<string>;
  public token!: Observable<string>;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      // Client only code.
      this.tokenSubject = new BehaviorSubject<string>(
        localStorage.getItem("access_token") ?? "",
      );
      this.token = this.tokenSubject.asObservable();
    }

    if (isPlatformServer(this.platformId)) {
      // Server only code.
    }
  }

  public get tokenValue(): string {
    return this.tokenSubject.value;
  }

  public set tokenValue(value) {
    localStorage.setItem("access_token", value);
    this.tokenSubject.next(value);
  }

  public isAuthenticated() {
    return !!(this.tokenValue && this.tokenValue.length);
  }

  public isAuthenticated$() {
    return this.tokenSubject.pipe(map((tokenValue) => !!tokenValue));
  }

  login(login: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/login`, { login, password })
      .pipe(
        map((data) => {
          // login successful if there's a jwt token in the response
          if (data && data.access_token) {
            // store jwt token in local storage to keep user logged in between page refreshes
            this.tokenValue = data.access_token;
          }

          return data.access_token;
        }),
      );
  }

  logout() {
    localStorage.removeItem("access_token");
    this.tokenSubject.next("");
    this.router.navigate(["/login"]);
  }
}
